import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { LightboxComponent } from './lightbox.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CbLoadingSpinnerModule } from 'cb-hub-lib';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

const COMPONENTS = [
    LightboxComponent,
];

@NgModule({
    declarations: COMPONENTS,
    imports: [
        CommonModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        CbLoadingSpinnerModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: COMPONENTS
})
export class CbLightboxModule { }
